import { render, staticRenderFns } from "./TJ-Icon.vue?vue&type=template&id=436bb8da&scoped=true&"
import script from "./TJ-Icon.vue?vue&type=script&lang=js&"
export * from "./TJ-Icon.vue?vue&type=script&lang=js&"
import style0 from "./TJ-Icon.vue?vue&type=style&index=0&id=436bb8da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436bb8da",
  null
  
)

export default component.exports